import Vue from 'vue';
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter)

const routes = [
    {
        // path: '/', name: 'homepage', component: () => import('../views/Homepage.vue')
        path: '/', name: 'Login', component: () => import('../views/Login.vue')
    },{
        path: '/overview', name: 'overview', component: () => import('../views/exam/readList.vue')
    },{
    //     path: '/tmp', name: 'tmp', component: () => import('../views/exam/listen/listenResultTmp.vue')
    // },{
        path: '/100', name: '100', component: () => import('../views/exam/100/100.vue')
    },{
        path: '/1', name: '100', component: () => import('../views/exam/100/100List.vue')
    },{
        path: '/writelist', name: 'writelist', component: () => import('../views/exam/writeList.vue')
    },{
        path: '/speaklist', name: 'speaklist', component: () => import('../views/exam/speakList.vue')
    },{
        path: '/listenlist', name: 'listenlist', component: () => import('../views/exam/listenList.vue')
    },{
        path: '/toefl2026', name: 'toefl2026', component: () => import('../views/exam/toefl2026.vue')
    }, {
        path: '/read2026/:taskId', name: 'read2026', component: () => import('../views/exam/read2026/read2026.vue')
    },
    {
        path: '/exam/', component: Home, name: 'exam', redirect: '/overview', //重定向
        children: [{
            path: 'read', name: 'read', component: () => import('../views/exam/read/read.vue')
        },{
            path: 'rresult', name: 'rresult', component: () => import('../views/exam/read/readResult.vue')
        },{
            path: 'rresultmock', name: 'rresultmock', component: () => import('../views/exam/read/readResultMock.vue')
        },{
            path: 'lresultmock', name: 'lresultmock', component: () => import('../views/exam/listen/listenResultMock.vue')
        },{
            path: 'sresultmock', name: 'sresultmock', component: () => import('../views/exam/speak/speakResultMock.vue')
        },{
            path: 'wresultmock', name: 'wresultmock', component: () => import('../views/exam/write/writeResultMock.vue')
        },{
            path: 'lresult', name: 'lresult', component: () => import('../views/exam/listen/listenResult.vue')
        },{
            path: 'wresult', name: 'wresult', component: () => import('../views/exam/write/writeResult.vue')
        },{
            path: 'sresult', name: 'sresult', component: () => import('../views/exam/speak/speakResult.vue')
        },{
            path: 'rdirection', name: 'rdirection', component: () => import('../views/exam/read/direction.vue')
        },{
            path: 'listen', name: 'listen', component: () => import('../views/exam/listen/listen.vue')
        },{
            path: 'ldirection', name: 'ldirection', component: () => import('../views/exam/listen/ldirection.vue')
        },{
            path: 'speak1', name: 'speak1', component: () => import('../views/exam/speak/speakP1.vue')
        },{
            path: 'speak2', name: 'speak2', component: () => import('../views/exam/speak/speakP2.vue')
        },{
            path: 'speak3', name: 'speak3', component: () => import('../views/exam/speak/speakP3.vue')
        },{
            path: 'speak4', name: 'speak4', component: () => import('../views/exam/speak/speakP4.vue')
        },{
            path: 'sdirection', name: 'sdirection',  component: () => import('../views/exam/speak/sdirection.vue')
        },{
            path: 'srecordtest',name: 'srecordtest', component: () => import('../views/exam/speak/recordtest.vue')
        },{
            path: 'write', name: 'write1', component: () => import('../views/exam/write/writeP1.vue')
        },{
            path: 'wdirection', name: 'wdirection', component: () => import('../views/exam/write/wdirectionP1.vue')
        },{
            path: 'write2', name: 'write2', component: () => import('../views/exam/write/writeP2.vue')
        },{
            path: 'wdirection2', name: 'wdirection2', component: () => import('../views/exam/write/wdirectionP2.vue')
        }],
    }, {
    //     path: '/login', name: 'login', component: () => import('../views/LoginWX.vue'),
    // }, {
    //     path: '/login', name: 'login', component: () => import('../views/Login.vue')
    // }, {
        path: '/xufei', name: 'xufei', component: () => import('../views/xufei.vue')
    }, {
        path: '/register', name: 'register', component: () => import('../views/Register.vue'),
    }, {
        path: '/find', name: 'find', component: () => import('../views/FindPswd.vue'),
    }, {
        path: '/agreement', name: 'agreement', component: () => import('../views/ServiceContract.vue')
    }, {
        path: '/about', name: 'about', component: () => import('../views/About.vue')
    }, {
        path: '/contact', name: 'contact', component: () => import('../views/Contact.vue')
    }, {
        path: '/join', name: 'join', component: () => import('../views/JoinUs.vue')
    }, {
        path: '/price', name: 'price', component: () => import('../views/Price.vue')
    // }, {
    //     path: '/membership', name: 'MembershipPlan', component: () => import('../views/membership/MembershipPlan.vue')
    // }, {
    //     path: '/payment/:orderNo', name: 'PaymentPage', component: () => import('../views/membership/PaymentPage.vue')
    // }, {
    //     path: '/payment-result', name: 'PaymentResult', component: () => import('../views/membership/PaymentResult.vue')
    // }, {
    //     path: '/orders', name: 'OrderList', component: () => import('../views/membership/OrderList.vue')
    },
    // 2026 TOEFL Reading Routes
    {
        path: '/read2026x', name: 'read2026list', component: () => import('../views/exam/read2026/Read2026List.vue')
    }, {
        path: '/read2026x/practice/:type', name: 'read2026practice', component: () => import('../views/exam/read2026/Read2026Practice.vue')
    },{
        path: '/readResultMock2026/:recordId', name: 'readResultMock2026', component: () => import('@/views/exam/read2026/readResultMock2026.vue')
    },
    // 2026 TOEFL Listening Routes
    {
        path: '/listen2026/:taskId', name: 'listen2026', component: () => import('../views/exam/listen2026/listen2026.vue')
    },{
        path: '/listenResultMock2026/:recordId', name: 'listenResultMock2026', component: () => import('@/views/exam/listen2026/listenResultMock2026.vue')
    },
    // 2026 TOEFL Writing Routes
    {
        path: '/write2026/:taskId', name: 'write2026', component: () => import('../views/exam/write2026/write2026.vue')
    },{
        path: '/writeResultMock2026/:recordId', name: 'writeResultMock2026', component: () => import('@/views/exam/write2026/writeResultMock2026.vue')
    },

    // 2026 TOEFL Speaking Routes
    {
        path: '/recordtest2026/:taskId', name: 'recordtest2026', component: () => import('../views/exam/speak2026/recordtest2026.vue')
    },
    {
        path: '/speak2026/:taskId', name: 'speak2026', component: () => import('../views/exam/speak2026/speak2026.vue')
    },{
        path: '/speakResultMock2026/:recordId', name: 'speakResultMock2026', component: () => import('@/views/exam/speak2026/speakResultMock2026.vue')
    },

// 2026 TOEFL full Routes
    {
        path: '/fullExam2026/:taskId',
        name: 'fullExam2026',
        component: () => import('@/views/exam/fullExam2026/fullExam2026.vue')
    },
    {
        path: '/fullExamResult2026/:examRecordId',
        name: 'fullExamResult2026',
        component: () => import('@/views/exam/fullExam2026/fullExamResult2026.vue')
    }

]

const router = new VueRouter({
    // require service support
    mode: 'history',
    routes // short for `routes: routes`
})

export default router

